// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__19ATq","title":"Header_title__gZMbU","left":"Header_left__2ntdA","clinicName":"Header_clinicName__1kOdp"};